<template>
	<div class="solution-summary pb-2">
		<b-card no-body v-if="listProduct.length > 0">
			<b-card-header header-bg-variant="primary" header-class="p-2 text-white">
				Refinance
			</b-card-header>
			<b-card-body class="px-4 py-2">
				<b-row class="mb-3 pt-2" v-for="(product, index) in listProduct" :key="index">
					<b-col cols="12" md="12">
						<b-row v-for="(bank, index) in product.product_banks" :key="index">
							<div class="d-flex justify-content-between w-100">
								<el-image class="rounded mb-2" :src="bank.prod_bnk_logo_url" fit="cover"
									style="height: 25px;"></el-image>
								<a href="javascript:void(0)" class="pr-3" @click="removePropertyProductBankHandler(bank)"><b-icon
										icon="x-circle-fill" class="text-danger"></b-icon></a>
							</div>
							<b-col cols="12">
								<b-row>
									<b-col cols="12" md="3" class="mb-3">
										<label class="font-weight-bold">Loan Amount</label>
										<p>RM{{ bank.prod_bnk_loan_amount | moneyFormatter }}</p>
									</b-col>
									<b-col cols="12" md="3" class="mb-3">
										<label class="font-weight-bold">Interest Rate</label>
										<p>{{ bank.prod_bnk_interest }}%</p>
									</b-col>
									<b-col cols="12" md="3" class="mb-3">
										<label class="font-weight-bold">Tenure</label>
										<p>{{ bank.prod_bnk_tenure }} Years</p>
									</b-col>
									<b-col cols="12" md="3" class="mb-3">
										<label class="font-weight-bold">Installment</label>
										<p>RM{{ bank.prod_bnk_installment | moneyFormatter }}</p>
									</b-col>
									<b-col cols="12" md="3" class="mb-3">
										<label class="font-weight-bold">Arrangement Fee (RM)</label>
										<p>RM{{ bank.prod_bnk_agreement_rate | moneyFormatter }}</p>
									</b-col>
								</b-row>
							</b-col>
						</b-row>
						<b-row v-if="product.product_banks.length === 0" class="mb-1">
							<b-col>
								<p class="py-4">No Bank Found.</p>
							</b-col>
						</b-row>
					</b-col>
					<b-col cols="12" class="mx-auto mt-1 pb-1">
						<b-row>
							<b-col cols="12">
								<div class="d-flex justify-content-between align-items-center">
									<el-button type="text" @click="addBank(product.prod_id)">
										<svg xmlns="http://www.w3.org/2000/svg" width="12" height="16" viewBox="0 0 448 512">
											<path fill="currentColor"
												d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32v144H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h144v144c0 17.7 14.3 32 32 32s32-14.3 32-32V288h144c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z" />
										</svg>
										Add Bank
									</el-button>
									<div>
										<el-button class="bg-info py-2 text-white" @click="generatePerformaInfoice(product)"
											:loading="is_loading.case && is_loading.value === product.prod_id">
											<small class="font-weight-bold text-white"
												v-if="_gHlp.isEmpty(product.proforma_invoice_id)">GENERATE PERFORMA INVOICE</small>
											<small class="font-weight-bold text-white" v-else>VIEW PERFORMA INVOICE</small>
										</el-button>
										<el-button class="bg-success py-2 text-white" @click="convertProductToCaseHandler(product.prod_id)"
											:loading="is_loading.case && is_loading.value === product.prod_id"><small
												class="font-weight-bold text-white">CONVERT TO CASE</small>
										</el-button>
										<el-button class="bg-danger py-2 text-white" @click="removeProductHandler(product)"
											:loading="is_loading.case && is_loading.value === product.prod_id"><small
												class="font-weight-bold text-white">REMOVE</small>
										</el-button>
									</div>
								</div>
							</b-col>
						</b-row>
					</b-col>
				</b-row>
			</b-card-body>
		</b-card>
		<div class="text-center mt-5" v-else>No draft found.</div>
		<DrawerProFormaInvoiceForm ref="drawer_proforma_invoice_form" @close="getRelatedInvoice()" />
	</div>
</template>
<script>
import { Image, Button } from 'element-ui'
import CurrencyInput from '@/components/CurrencyInput'
import { mapState, mapActions } from 'pinia'
import { useProductStore } from '@/stores/productStore'
import { useNotificationStore } from '@/stores/notificationStore'
import { useMessagingStore } from '@/stores/messagingStore'
import { useBillingStore } from '@/stores/billingStore'
import notifyFunctionMixin from '@/assets/js/notifyFunctionMixin.js'
import helperFunctionMixin from '@/assets/js/helperFunctionMixin.js'
import solutionEventBus from '@/assets/js/EventBus/solutionEventBus.js'
import DrawerProFormaInvoiceForm from '@/views/Sales/ProFormaInvoices/OffCanvasProFormaInvoices/ProFormaInvoiceForm'

import _ from 'lodash'

export default {
	props: ['is_active'],
	components: {
		CurrencyInput,
		DrawerProFormaInvoiceForm,
		[Image.name]: Image,
		[Button.name]: Button,
	},
	mixins: [notifyFunctionMixin, helperFunctionMixin],
	data() {
		return {
			listInvoice: [],
			listProduct: [],
			is_loading: {
				case: false,
				value: ''
			},
		}
	},
	watch: {
		listInvoice: {
			handler(newVal) {
				this.injectProducts();
			},
			immediate: true
		},
		refinance_draft_products: {
			handler(newVal) {
				this.injectProducts();
			},
			immediate: true
		},
		is_active: {
			handler(newVal) {
				if (newVal) {
					this.getRelatedInvoice();
				}
			},
			immediate: true
		},
	},
	computed: {
		...mapState(useProductStore, ['refinance_draft_products']),
	},
	methods: {
		...mapActions(useBillingStore, ['getInvoices']),
		...mapActions(useProductStore, ['removeProduct', 'convertProductToCase', 'removePropertyProductBank']),
		...mapActions(useNotificationStore, ['fetchEmailTemplate']),
		...mapActions(useMessagingStore, ['sendEmail']),
		async removePropertyProductBankHandler(bank) {
			try {
				await this.removePropertyProductBank(bank)
				this.notifySuccess('<b>Bank </b> - Successfully Removed.')
			} catch (e) {
				this.errorFunction(null, e)
			}
		},
		addBank(product_id, project_id) {
			this.$router.replace({
				query: Object.assign({ ...this.$route.query },
					{
						product_id: product_id,
					}
				),
			}, () => { })
			solutionEventBus.$emit('show-refinancing-bank')
		},
		resetIsLoading() {
			this.is_loading.case = false
			this.is_loading.value = null
		},
		async convertProductToCaseHandler(id) {
			this.is_loading.case = true
			this.is_loading.value = id
			try {
				await this.convertProductToCase(id, 'refinance')
				await this.sendCaseApprovalEmail(id)
				this.resetIsLoading()
				this.notifySuccess('<b>Case Successfully Created </b> - Pending Approval.')
			} catch (e) {
				this.errorFunction(e)
				this.resetIsLoading()
				return
			}
		},
		async sendCaseApprovalEmail(id) {
			try {
				const emailTemplate = await this.fetchEmailTemplate('CREATE_CASE_APPROVAL');
				if (emailTemplate && emailTemplate.is_active == 1) {

					const recipients = emailTemplate.notif_temp_receiver.split(',').map(email => email.trim());

					// Prepare the email data
					const emailData = {
						to: recipients,
						subject: emailTemplate.notif_temp_title,
						body: emailTemplate.notif_temp_message
							.replace('{case_id}', id) // Replace {case_id} with product ID
					};

					await this.sendEmail(emailData);
					this.notifySuccess('Email sent successfully.');
				}
			}
			catch (error) {
				console.error('Failed to send email:', error);
				this.errorFunction(error);
			}
		},
		async removeProductHandler(product) {
			try {
				await this.removeProduct(product)
				this.notifySuccess('<b>Draft </b> - Successfully Removed.')

			} catch (e) {
				this.errorFunction(null, e)
			}
		},

		async generatePerformaInfoice(product) {
			const inv = this.listInvoice.find((i) => { return i.inv_id === product.proforma_invoice_id })
			if (!_gHlp.isEmpty(inv)) {
				this.$refs.drawer_proforma_invoice_form.show(inv)
			} else {
				const newProformaInv = {
					inv_user_id: product.prod_customer_id,
					inv_user_type: 'customer',
					inv_user_name: product.prod_customer_name,
					inv_custom_identity: '#' + product.prod_id + '_product',
					inv_stm_id: null, //if set will check existing
					inv_scrb_id: null, //if set will check existing
					inv_pckg_id: null, //if set will check existing
					inv_title: null,
					inv_description: null,
					inv_ref_no: 'INV_PROFORMA_' + product.prod_id + '_PRODUCT',
					inv_issued_date: null,
					inv_status: 'DRAFT', //DRAFT,ISSUED,PAID,CANCELED
					inv_remark: null,
					inv_application_code: _gAuth.appCode(),
					inv_corporate_id: _gAuth.activeCorporateId(),
					inv_items: [
						{
							itm_tittle: 'Arrangement Fee',
							itm_description: '',
							itm_qty: 1,
							itm_amount: _gHlp.getValue(product, 'product_banks.0.prod_bnk_agreement_fees', 0),
							itm_total: _gHlp.getValue(product, 'product_banks.0.prod_bnk_agreement_fees', 0),
						}
					],
				}
				this.$refs.drawer_proforma_invoice_form.show(newProformaInv)
			}

		},
		injectProducts() {
			const listProduct = _.clone(this.refinance_draft_products)
			listProduct.forEach(item => {
				const inv = this.listInvoice.find((i) => { return i.inv_custom_identity === '#' + item.prod_id + "_product" })
				if (!_gHlp.isEmpty(inv)) {
					item['proforma_invoice_id'] = inv.inv_id
				} else {
					item['proforma_invoice_id'] = null
				}
			});
			this.listProduct = listProduct;
		},
		getRelatedInvoice() {
			if (_gHlp.isEmpty(this.refinance_draft_products)) return;
			const identifiers = this.refinance_draft_products.map((item) => { return "#" + item.prod_id + "_product" });
			this.getInvoices({
				pagination: { limit: 100 },
				search: {
					inv_custom_identity: identifiers.join(','),
					inv_type: "PROFORMA",
				}
			}).then((resp) => {
				this.listInvoice = _gHlp.getValue(resp, 'content', [])
			})
		}
	}
}
</script>